import React from "react"

import Header from "../parts/Header"
import AuthActions from '../../actions/AuthActions';
import AuthStore from '../../stores/AuthStore';
import MemberActions from '../../actions/MemberActions';
import MemberStore from "../../stores/MemberStore"
import HeaderMember from '../parts/HeaderMember'

import  '../../styles/member.css'
/*
var getInvoiceState = () => {
  return InvoiceStore.getAll()
}
*/

export default class MemberApp extends React.Component {

  constructor(){
    super()

    AuthActions.setAuth()
    this.memberStoreChangeHandler = this.memberStoreChangeHandler.bind(this)
    this.state = {
      members:[]
    }
  }

  componentDidMount(){
    MemberStore.addChangeListener(this.memberStoreChangeHandler, "list_loaded")
    MemberActions.getList(AuthStore.getToken())
  }


  componentWillUnmount(){
    MemberStore.removeChangeListener(this.memberStoreChangeHandler, "list_loaded")
  }


  memberStoreChangeHandler(){
    this.setState({
      members:MemberStore.getList()
    })
  }


  render(){

    const member_list = this.state.members.map((item) => {

      return <div className="member-list-item"><div className="icon">{item.picture ? <img src={item.picture} /> : <i className="fas fa-user"></i>}</div><div>{item.name}</div></div>
    })

    return(
      <div>
      <HeaderMember />
      <main>
        <Header />
        <div className="main-pannel">
        <h1>MyPage</h1>
        <h2>お知らせ</h2>
        <div className="news">
            <div className="news-item"><div className="date">2019.05.28</div><div>メンバー一覧をアップしました。</div></div>
        </div>

        <h2>Member一覧</h2>
        <div className="member">
          {member_list}
        </div>


        </div>
      </main>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/member/MemberApp.js